<template>
 <!-- 合同名头管理 -->
  <div>
    <div v-show="Jfmtgl">
      <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">合同名头管理</div>
    <!-- 主体 -->
    <div style="height:750px;background-color:white;margin:75px 40px 0 40px">
      <!-- 查询框 -->
      <div style="margin-left:3%">
        <div style="height:40px"></div>
        <div style="display:inline-block;margin-left:20px">
            <span>甲方名称 </span>
          <el-input v-model="condition.partner_name" style="margin-left:10px;width:170px" 
                    placeholder="请输入甲方名称"></el-input>
        </div>

        <!-- 按钮 -->
        <div style="display:inline-block;margin-left:20px">
          <el-button type="goon" @click="Find">查询</el-button>
          <el-button type="goon" >删除</el-button>
          <el-button type="addbtn" @click="add()">新增</el-button>
          <div style="display:inline-block;margin-left:220px">
										<download-excel class="export-excel-wrapper" :fields="download_excel" title="证照信息"
													name="合同名头清单.xls" :fetch="ExportForm"
													style="margin-left:-180px;top:100px">
											<el-button type="goon" style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
												导表</el-button>
										</download-excel>
									</div>
        </div>
        
      </div>

      <!-- 表格 -->
      <div style="margin:3% 3% 0 3%" >
        <el-table
          :header-cell-style="{background:'#F0F0F0',color:'#000000'}" height="574px"
          :row-class-name="tableRowClassName"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;height:540px"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
          </el-table-column>
          <el-table-column prop="partner_name" align="center" label="执照全称"></el-table-column>
		  <el-table-column prop="partner_abbreviation" align="center" label="执照简称"></el-table-column>
          <el-table-column prop="opening_bank" align="center" label="开户行"></el-table-column>
          <el-table-column prop="bank_account" align="center"  label="开户行账号"></el-table-column>
          <el-table-column prop="partner_address" align="center" label="经营地址"></el-table-column>
          <el-table-column prop="partner_contact" align="center" label="联系电话" width="120"></el-table-column>
          <el-table-column prop="partner_represent" align="center" label="法人代表" width="80"></el-table-column>
          <el-table-column align="center" label="操作" >
            <template slot-scope="scope">
              <img src="../../../assets/编辑.png" @click="UpdateFrom(scope.row)">
              <img src="../../../assets/删除.png" @click="Del(scope.row.id)" style="margin-left: 10px"/>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-row style="margin-top: 10px; text-align: center;">
          <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
            layout=" prev, pager, next, jumper" :total="total">
          </el-pagination>
        </el-row>
      </div> 
      
    </div>
    </div>
    
    <!-- 签订 -->
    <el-dialog
      :title="ruleForm.id == null || ruleForm.id == '' ? '添加' : '修改'"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
      :center="true"
      :before-close="handleClose">
      <add ref="adds" v-show="showadd"  :ruleForm="ruleForm"></add>
    </el-dialog>
  </div>
</template>

<script>
import add from './Jfmtgl_add.vue';
export default {
  components: {
    add:add,
  },
  data() {
    return {
      page_num: 1,
      page_size: 10,
      total: 0,
      dialogVisible:false,
      tableData:[],
      // 权限
      Jfmtgl:true,
      showadd:false,
      ids: [],
      ruleForm: {
        id:"",
        partner_name:"",
        opening_bank:"",
        bank_account:"",
        partner_address:"",
        partner_contact:"",
        partner_represent:"",
        partner_abbreviation:"",
        register_addres:"",
        partner_code:"",
        abbreviation_code:"",
        register_address:"",
        tax_rate:"",
      },
      //条件
      condition: {
        id:"",
        partner_name: "",
      },
      download_excel: {
        "执照全称": "partner_name",
        "开户行": "opening_bank",
        "开户行账号": "bank_account",
        "经营地址":"partner_address",
        "联系电话": "partner_contact",
        "法人代表": "partner_represent",
        "执照简称": "partner_abbreviation",
        "注册地址": "register_address",
        "执照代码": "partner_code",
        "简称编码":"abbreviation_code",
        "营业期限开始":"start_date",
        "营业期限截至":"end_date",
      },


    }
  },
  methods: {
    // 全选
    handleSelectionChange(val) {
        this.ids = [];
        e.forEach(item => {
        this.ids.push(item.id);
      })
    },
    // 弹窗
    handleClose() {
    this.dialogVisible = false
    },
    // 新增
    add(){
      this.trash();
      this.dialogVisible = true;
      this.showadd = true;
      this.$refs.adds.add;
      this.trash();
    },
    //编辑页面
    UpdateFrom(e) {
      this.trash();
      this.showadd = true;
      this.dialogVisible = true;
      this.ruleForm.id = e.id;
      this.ruleForm.partner_name = e.partner_name;
      this.ruleForm.opening_bank = e.opening_bank;
      this.ruleForm.bank_account = e.bank_account;
      this.ruleForm.partner_address = e.partner_address;
      this.ruleForm.partner_contact = e.partner_contact;
      this.ruleForm.partner_represent = e.partner_represent;
      this.ruleForm.partner_abbreviation = e.partner_abbreviation;
      this.ruleForm.register_address = e.register_address;
      this.ruleForm.partner_code = e.partner_code;
      this.ruleForm.abbreviation_code = e.abbreviation_code;
      this.ruleForm.tax_rate = e.tax_rate;
    },
    // 操作删除
    async Del(e) {
        var url = "partner/del";
        var record = {
          ids:[e],
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === "-2000") {
            this.$message.error("服务器未响应！请稍后重试");
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                this.$message.success(data);
                this.trash();
                this.Find();
            } else {
                this.$message.warning(data);
            }
        }
    },
    //查询
    async Find() {
        var url = "partner/SelectAll";
        var record = {
            page_num: this.page_num,
            page_size: this.page_size,
            data_grouping: "Jfmtgl",
            partner_name: this.condition.partner_name,
            opening_bank:this.condition.opening_bank,
            bank_account:this.condition.bank_account,
            partner_address:this.condition.partner_address,
            partner_contact:this.condition.partner_contact,
            partner_represent:this.condition.partner_represent,
            partner_abbreviation:this.condition.partner_abbreviation,
            register_address:this.condition.register_address,
            partner_code:this.condition.partner_code,
            abbreviation_code:this.condition.abbreviation_code,
            tax_rate:this.condition.tax_rate,
        };
        var data = await this.$globals.AxiosPost(url, record);
        if (data === "-2000") {
            this.$message.error("服务器未响应！请稍后重试");
        } else {
            var code = data.code;
            var data = data.data;
            if (code === '200') {
                this.tableData = data.list;
                this.total = data.total;
            } else {
                this.$message.warning("请求失败！请稍后重试");
            }
        }
    },

    //导表
			async ExportForm(){
				var url = 'partner/SelectAlls';
				var record = {
					partner_name: this.condition.partner_name,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if(data.length > 0){
							this.$message.success("导表成功！文件下载中！");
							return data;
						}else{
                            this.$message.success("没有可以导出的数据！");
                            return null;
                        }
						
					}
				}
			},




    //分页
    handleCurrentChange(val) {
        this.page_num = val;
        this.Find();
    },
      //清除数据
      trash() {
        this.ruleForm.id = "";
        this.ruleForm.partner_name = "";
        this.ruleForm.opening_bank = "";
        this.ruleForm.bank_account = "";
        this.ruleForm.partner_address = "";
        this.ruleForm.partner_contact = "";
        this.ruleForm.partner_represent = "";
        this.ruleForm.partner_abbreviation = "";
        this.ruleForm.register_address = "";
        this.ruleForm.partner_code = "";
        this.ruleForm.abbreviation_code = "";
        this.ruleForm.tax_rate = "";
      }
  },
  created() {
    this.Find();
  }
}
</script>

<style>
.el-button--goon:focus,
.el-button--goon:hover {
  background: #006E4B;
  border-color:  #05573d;
  color: #fff;
}
.el-button--addbtn:focus,
.el-button--addbtn:hover {
  background: #fff;
  border-color:  #05573d;
  color:  #006E4B;
}
.el-button--goon {
  color: #FFF;
  background-color: #006E4B;
  border-color:  #006E4B;
  font-size: 15px;
  width: 85px;
}
.el-button--addbtn {
  color:  #006E4B;
  background-color: #fff;
  border-color:  #006E4B;
  font-size: 15px;
  width: 85px;
}
.el-table .warning-row {
  background: oldlace;
}
.el-table .success-row {
  background: #f0f9eb;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color:  #006E4B;
  border-color:  #006E4B;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color:  #006E4B;
}
.el-checkbox__inner:hover{
  border-color:  #006E4B;
}
</style>


// WEBPACK FOOTER //
// Jfmtgl.vue?6ea79e86